<template>
    <Form @submit="submit">
        <div class="auth-page">
            <div class="container-fluid p-0">
                <div class="row g-0 align-items-center">
                    <div class="col-xxl-12 col-lg-12 col-md-12">
                        <div class="row justify-content-center g-0">
                            <div class="col-xl-4">
                                <div class="p-4">
                                    <div class="card mb-0">
                                        <div class="card-body">
                                            <div class="auth-full-page-content rounded d-flex p-3 my-2">
                                                <div class="w-100">
                                                    <div class="d-flex flex-column h-100">
                                                        <div class="mb-4 mb-md-5 text-center">
                                                            <router-link to="/" class="d-block auth-logo">
                                                                <img src="@/assets/images/logo.svg" alt=""
                                                                     height="45"
                                                                     class="auth-logo-dark mx-auto">
                                                                <img src="@/assets/images/logo.svg" alt=""
                                                                     height="45"
                                                                     class="auth-logo-light mx-auto">
                                                            </router-link>
                                                        </div>
                                                        <div class="auth-content my-auto">
                                                            <div class="text-center">
                                                                <h5 class="mb-0">歡迎您回來 !</h5>
                                                                <p class="text-muted mt-2">登入進入 SaaS 管理系統</p>
                                                            </div>

                                                            <div class="form-floating form-floating-custom mb-4">
                                                                <Field
                                                                    id="username-input"
                                                                    name="username"
                                                                    :rules="{required:true}"
                                                                    maxLength="50"
                                                                    v-model="form.account"
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder="Enter User Name"/>
                                                                <label for="username-input">使用者帳號</label>
                                                                <div class="form-floating-icon">
                                                                    <eva-icon name="people-outline"></eva-icon>
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="form-floating form-floating-custom mb-4 auth-pass-inputgroup">
                                                                <Field
                                                                    id="password-input"
                                                                    name="password"
                                                                    :rules="{required:true}"
                                                                    maxLength="50"
                                                                    v-model="form.password"
                                                                    type="password"
                                                                    class="form-control"
                                                                    placeholder="Enter User Name"/>
                                                                <label for="password-input">密碼</label>
                                                                <div class="form-floating-icon">
                                                                    <eva-icon name="lock-outline"></eva-icon>
                                                                </div>
                                                            </div>

                                                            <div class="mb-3">
                                                                <button
                                                                    class="btn btn-primary w-100 waves-effect waves-light"
                                                                    type="submit"
                                                                    :disabled="isCloseBtn">登入
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="mt-4 text-center">
                                                            <p class="mb-0">© {{ new Date().getFullYear() }} 維護建立 by
                                                                Grapala
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end auth full page content -->
                    </div>
                    <!-- end col -->

                </div>
                <!-- end row -->
            </div>
            <!-- end container fluid -->
        </div>
    </Form>
</template>

<script>

import {ref, reactive} from 'vue';
import axios from "axios";
import {Form, Field} from "../../../components/form";
import {authMethods} from "@/state/helpers";
import Swal from 'sweetalert2';

export default {
    setup() {
        const form = reactive({
            account: '',
            password: ''
        });

        const isCloseBtn = ref(false);
        const resultMessage = ref('');
        return {form, resultMessage, isCloseBtn};
    },
    components: {
        Form,
        Field,
    },
    methods: {
        ...authMethods,
        setLogin(value) {
            return this.login({cookieToken: value});
        },
        setAccessToken(value) {
            return this.changeAccessToken({accessToken: value});
        },
        setRefreshToken(value) {
            return this.changeRefreshToken({refreshToken: value});
        },
        setSystemCode(value) {
            return this.changeSystemCode({systemCode: value});
        },
        setOrganizationCode(value) {
            return this.changeOrganizationCode({organizationCode: value});
        },
        setAccountState(value) {
            return this.changeAccount({account: value});
        },
        setUserNameState(value) {
            return this.changeUserName({userName: value});
        },
        setIsAuth(value) {
            return this.changeIsAuth({isAuth: value});
        },
        setRoleState(value) {
            return this.changeRole({role: value});
        },
        setScopeState(value) {
            return this.changeScope({scope: value});
        },
        setAccount(value) {
            this.form.account = value;
            this.v$.account.$touch();
        },
        setPassword(value) {
            this.form.password = value;
            this.v$.password.$touch();
        },
        submit() {
            this.isCloseBtn = true;
            this.doPost();
        },
        doPost() {
            let form = {
                Account: this.form.account,
                Password: this.form.password
            };
            let self = this;
            axios({
                method: "post",
                url: "/api/AuthOperator",
                headers: {
                    "content-type": "application/json",
                },
                withCredentials: true,
                data: form,
            })
                .then((response) => {
                    let result = response.data.value;
                    self.setLogin({
                        accessToken: result.accessToken,
                        refreshToken: result.refreshToken,
                        systemCode: result.systemCode || result.belongSystemCode,
                        organizationCode: result.organizationCode,
                        scopes: result.scopes,
                        roles: result.roles,
                        account: result.account,
                        userName: result.userName
                    });
                    // self.setAccessToken(result.accessToken);
                    // self.setRefreshToken(result.refreshToken);
                    // self.setAccountState(result.account);
                    // self.setRoleState(result.roles);
                    // self.setScopeState(result.scopes);
                    self.setIsAuth(true);
                    self.isCloseBtn = false;
                    self.resultMessage = "";
                    this.$router.push({path: "/"});
                })
                .catch((error) => {
                    const errorMessage = error.response?.data?.message
                        || error.message
                        || "登入失敗，請確認 Auth.Admin.WebApi 是否啟動且前端 proxy 設定正確";

                    Swal.fire("登入失敗", errorMessage, "error");
                    self.resultMessage = errorMessage;
                    self.setIsAuth(false);
                    self.isCloseBtn = false;
                });
        }
    }
}
</script>
